import React from 'react'
import { Menu } from '@mui/material'
import { BiMap, BiInfoCircle } from 'react-icons/bi'
import { ImHammer2 } from 'react-icons/im'
import { RiCustomerService2Line } from 'react-icons/ri'
import { TbLogout } from 'react-icons/tb'
import RouterHook from '../../../../contexts/RouterHook'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { Alerts, CompCnfg } from '../../../Simple'
import { AuthContext } from '../../../../contexts/AuthContext'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'

export default function MenuSettings({ open, handleClose, anchorEl }) {
  const serverRouter = RouterHook()

  const { actionsAuth } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { actionsCtxEmps } = React.useContext(EmpresasContext)

  const configs = [
    {
      Icon: ManageAccountsIcon,
      title: userUCtx.usuario.nome,
      describe: 'Editar meus dados pessoais.',
      user: true,
      onClick: () => {
        serverRouter('settings', userUCtx.usuario.idusuario)
      },
    },
    {
      Icon: ImHammer2,
      title: 'Aspectos legais',
      describe: 'Termo de uso, privacidade, dados...',
      onClick: () => {
        serverRouter('aspectLegal', userUCtx.usuario.idusuario)
      },
    },
    {
      Icon: BiMap,
      title: 'Alterar localização',
      describe: `${userUCtx.usuario.cidade}, ${userUCtx.usuario.estado}`,
      onClick: () => {
        actionsCtxEmps.handleModaisCE('modalL', true)
      },
    },
    {
      Icon: RiCustomerService2Line,
      title: 'Central de atendimento',
      describe: 'Precisa de ajuda?',
      onClick: () => {
        window.open('https://www.agendeiquadras.com.br/chatSuporteUsuarioAgendei.html', '_blank')
      },
    },
    {
      Icon: BiInfoCircle,
      title: 'Sobre',
      describe: 'Conheça mais do Agendei Quadras',
      onClick: () => {
        //navegar para a tela de sobre
        window.open('https://www.agendeiquadras.com.br/appAgendei/', '_blank')
      },
    },
    {
      Icon: TbLogout,
      title: 'Desconectar da conta',
      describe: 'Voltar à página inicial',
      onClick: () => {
        Alerts.question('Aviso', 'Deseja realmente sair?', async () => {
          await actionsAuth.StartLogout()
          serverRouter('login')
        })
      },
    },
  ]

  return (
    <Menu
      anchorEl={anchorEl}
      id='account-menu'
      open={open}
      onClose={() => handleClose('config')}
      onClick={() => handleClose('config')}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          padding: '0px',
          borderRadius: 2,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {configs.map((item, index) => {
        return (
          <CompCnfg key={index} ic={index} Icon={item.Icon} title={item.title} describe={item.describe} user={item.user} onClick={item.onClick} />
        )
      })}
    </Menu>
  )
}
